import { Box, Grid, Popover, Tooltip } from '@mui/material'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import useBoolean from 'utils/customHook/useBoolean'
import useSandreList from 'utils/customHook/useSandreList'
import { orderBy } from 'lodash'
import { Translate } from '@mui/icons-material'
import { actionIconStyle } from 'components/ActionUtil'

const LanguagesList = ({
    onClick = () => {},
}) => {
    const {
        value: isOpen,
        setTrue: open,
        setFalse: close,
    } = useBoolean(false)

    const [anchorEl, setAnchorEl] = useState()

    const id = isOpen ? 'simple-popper' : undefined
    const languages = useSandreList('LANGUES')

    return (
        <Box
            px={2}
        >
            <Tooltip title={i18n.languages} id={'dropdown_navbar'}>
                <Translate
                    id={id}
                    ref={anchorEl}
                    sx={{ ...actionIconStyle }}
                    onClick={e => {
                        open()
                        setAnchorEl(e.currentTarget)
                    }}
                />
            </Tooltip>
            <Popover
                open={isOpen}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                onClose={close}
            >
                {orderBy(languages, 'code').map((l, i) => (
                    <Grid
                        key={l.code}
                        container
                        sx={{
                            padding: '10',
                            cursor: 'pointer', '&:hover': {
                                backgroundColor: '#eee',
                            },
                            borderBottom: i < languages.length - 1 ? '1px solid #eee' : undefined,
                        }}
                        onClick={() => onClick(l)}
                    >
                        <Grid size={12}>
                            <h6>{l.mnemonique}</h6>
                        </Grid>
                    </Grid>
                ))}
            </Popover>
        </Box>
    )
}

LanguagesList.propTypes = {
    onClick: PropTypes.func,
}

export default LanguagesList
